import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import store from "./store"
import './styles/index.css'
import './assets/icons/iconfont.css'//引入阿里图标
import { initEnv } from './utils/env'
import { initVersionCheck } from './utils/versionCheck'

// 必须在挂载前执行：把 URL 上的 env 固化到 sessionStorage，
// 否则 vue-router 跳转后丢掉 query，小程序端的替代文案会失效
initEnv()

// web-view 里 index.html 被缓存时，用户会一直停在旧版本，
// 这里做一个惰性版本哨兵（非阻塞，失败静默降级）
initVersionCheck()

// 历史遗留的"应用版本变化 → 清 localStorage 后重载"逻辑。
// 保留原意（版本变了要丢掉可能不兼容的本地缓存），但修掉三个坑：
//   1. 原先是 location.reload()，URL 不变 —— 只要 localStorage 写入失败
//      （web-view 隐私模式 / 存储被限），就会"清空→重载→再清空"无限刷新。
//   2. 它会顺带清掉其它模块写入的标记（例如版本哨兵的），互相打架。
//   3. 原先是整体 clear()，而登录态现在也存 localStorage —— 会把用户踢下线。
//      现改为只清缓存类 key，显式放行 user / store / appVersion。
// 改法：用 URL 上的一次性标记短路，任何情况下最多重载一次。
const VUE_APP_VERSION = require('../package.json').version
const APP_VERSION_KEY = 'appVersion'
const CLEARED_FLAG = 'appVersionClearedTo'
const vers = window.localStorage.getItem(APP_VERSION_KEY)
if (VUE_APP_VERSION != vers) {
    // 先写版本号再清空：原代码是 clear() 之后才写，一旦写入失败就会无限重载
    try {
        window.localStorage.setItem(APP_VERSION_KEY, VUE_APP_VERSION)
    } catch (e) {
        /* 存储不可用时忽略，避免反复重载 */
    }
    const url = new URL(window.location.href)
    const alreadyCleared = url.searchParams.get(CLEARED_FLAG) === VUE_APP_VERSION
    if (!alreadyCleared) {
        // ⚠️ 这里**不能**再整体 localStorage.clear()。
        // 登录态（user / store）自 2026-10-06 起也存 localStorage，
        // 全清会把用户直接踢下线 —— 每次发版都要重新登录，与"登录一次即可"的需求相悖。
        // 改为：只清「缓存类」的 key，显式放行登录态与版本号本身。
        const KEEP_KEYS = [APP_VERSION_KEY, 'user', 'store']
        try {
            Object.keys(window.localStorage)
                .filter((k) => !KEEP_KEYS.includes(k))
                .forEach((k) => window.localStorage.removeItem(k))
        } catch (e) {
            /* ignore */
        }
        url.searchParams.set(CLEARED_FLAG, VUE_APP_VERSION)
        window.location.replace(url.toString())
    }
}

const app = createApp(App);
app.use(store).use(router).use(store).mount('#app')
